import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const Container = styled.div`
  border-top: 4px solid ${Color.gray200};
  padding: 24px 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.54) 0%, rgba(255, 255, 255, 0.890625) 51.04%, #ffffff 100%), url("./assets/webb.png");

  @media (min-width: 1280px) {
    padding: 36px 0px;
  }
`

export const CopytightContainer = styled.div`
  padding: 0 12px;
  background: #0c4a6e;
`

export const Logo = styled.img`
  width: 96px;
  margin-bottom: 24px;

  @media (min-width: 1280px) {
    width: 120px;
    margin-top: -5px;
    margin-bottom: 0px;
  }
`
export const TMDBLogo = styled.img`
  width: 96px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex-direction: row;
  }
`
export const Title = styled.h4`
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 1px;
  line-height: 19px;
  color: ${Color.gray600};
  display: flex;

  & i {
    margin-left: 6px;
  }

  @media (min-width: 1280px) {
    margin-bottom: 10px;
  }
`

export const Item = styled.div`
  margin-bottom: 24px;

  @media (min-width: 1280px) {
    margin-bottom: 0;
    margin-right: 36px;
    &:last-child {
      margin-right: 0;
    }
  }
  &:last-child ${Title} {
    margin-bottom: 6px;
  }

  @media (min-width: 640px) {
    &:last-child ${Title} {
      text-align: right;
    }
  }
`

export const Text = styled.p`
  display: inline-block;
  font-size: 14px;
  color: ${Color.gray400};
  margin-right: 4px;
  line-height: 18px;
  display: flex;
  flex-wrap: wrap;

  & a {
    color: ${Color.secondary};
  }
  & a:hover {
    color: ${Color.primary};
  }

  & i {
    margin: 0 4px;
  }

  & span {
    margin-left: 2px;
  }
`

export const Body = styled.div`
  max-width: 222px;
  overflow: hidden;

  & ${Text} {
    display: block;
  }
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${Color.gray400};
`
export const FLink = styled(Link)`
  display: inline-block;
  font-size: 14px;
  color: ${Color.gray400};
  text-decoration: none;
  margin-right: 4px;
  line-height: 18px;
  transition: color 0.3s ease-in-out;

  @media (min-width: 1280px) {
    font-size: 14px;
  }

  &::after {
    content: ",";
    margin-left: 2px;
  }

  &:hover {
    color: ${Color.gray600};
  }
`

export const CopyrightWrapper = styled.div`
  padding: 12px 0;
  display: flex;
  justify-content: space-between;

  ${Text} {
    color: ${Color.gray200};
    letter-spacing: 0.6px;

    & span {
      color: ${Color.primary};
      font-weight: bold;
    }
  }
  ${Text}:last-child {
    display: none;
  }

  @media (min-width: 640px) {
    ${Text}:last-child {
      display: block;
    }
  }
`

export const SocialHandle = styled.div`
  margin-top: 6px;
`

export const SocialLink = styled(Link)`
  display: inline-block;
  font-size: 14px;
  color: ${Color.gray400};
  text-decoration: none;
  margin: 0 4px;
  line-height: 18px;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: ${Color.gray600};
  }
  & i {
    color: ${Color.gray400};
    transition: color 0.3s ease-in-out;
  }
  & i:hover {
    color: ${Color.gray600};
  }
`
